
import { Component, Emit, Prop, PropSync, Vue } from 'nuxt-property-decorator'
import { NeoButton, NeoField, NeoInput } from '@kodadot1/brick'

@Component({
  components: {
    NeoButton,
    NeoField,
    NeoInput,
  },
})
export default class AttributeInput extends Vue {
  @Prop(Number) index!: number
  @Prop(Boolean) disabled!: boolean
  @PropSync('trait_type', { type: String }) vKey!: string
  @PropSync('value', { type: [String, Number] }) vValue!: string | number

  @Emit('remove')
  protected remove() {
    return this.index
  }
}
